var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service-card"},[_c('div',{staticClass:"card-icon"},[_c('i',{class:_vm.icon})]),_c('h3',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"card-description"},[_vm._v(_vm._s(_vm.description))]),_c('div',{staticClass:"card-hover-overlay"},[_c('i',{class:_vm.icon})])])
}
var staticRenderFns = []

export { render, staticRenderFns }